import { EndPoint } from './EndPoint'
import { TableStoreId } from './TableStoreId'

/**
 * Collection of Pinia store ids and their corresponding REST endpoints suffix.
 */
export class TableStoreOptions {
  public static readonly AccountSettings = {
    id: TableStoreId.AccountSettings,
    endpoint: EndPoint.AccountSettings
  }

  public static readonly Admins = {
    id: TableStoreId.Admins,
    endpoint: EndPoint.Admins
  }

  public static readonly CustomFields = {
    id: TableStoreId.CustomFields,
    endpoint: EndPoint.CustomFields
  }

  public static readonly DailyChecks = {
    id: TableStoreId.DailyChecks,
    endpoint: EndPoint.DailyChecks
  }

  public static readonly Datasets = {
    id: TableStoreId.Datasets,
    endpoint: EndPoint.Datasets
  }

  public static readonly Devices = {
    id: TableStoreId.Devices,
    endpoint: EndPoint.Devices
  }

  public static readonly EmailTemplates = {
    id: TableStoreId.EmailTemplates,
    endpoint: EndPoint.EmailTemplates
  }

  public static readonly Events = {
    id: TableStoreId.Events,
    endpoint: EndPoint.Events
  }

  public static readonly Files = {
    id: TableStoreId.Files,
    endpoint: EndPoint.Files
  }

  public static readonly FitTests = {
    id: TableStoreId.FitTests,
    endpoint: EndPoint.FitTests
  }

  public static readonly Masks = {
    id: TableStoreId.Masks,
    endpoint: EndPoint.Masks
  }

  public static readonly MedicalClearances = {
    id: TableStoreId.MedicalClearances,
    endpoint: EndPoint.MedicalClearances
  }

  public static readonly People = {
    id: TableStoreId.People,
    endpoint: EndPoint.People
  }

  public static readonly PeoplePicker = {
    id: TableStoreId.PeoplePicker,
    endpoint: EndPoint.People
  }
}
